// 索引类型
export type DbIndex = {
  key: string;
  // eslint-disable-next-line no-undef
  option?: IDBIndexParameters;
};
export type DbTable = {
  tableName: string;
  // options: { keyPath: "id", autoIncrement: true } 默认:主键是 id，自增
  // eslint-disable-next-line no-undef
  options?: IDBObjectStoreParameters;
  // 索引类型:
  indexs?: DbIndex[];
};
export interface IIndexDB {
  dbName: string;
  version: number;
  tables: DbTable[];
}

// // 数据库适配器
// export interface DBAdapter<T> {
//   tableName: string;
//   key: string | number;
//   value: string | number;
//   data: T | T[];
//   condition(item: T): boolean;
//   handler(res: T): void;
//   success(res: T[] | T): void;
// }

export class IndexDB {
  // 数据库名
  private dbName: string = '';
  private version: number = 1;
  // eslint-disable-next-line no-undef
  private db: IDBDatabase | null = null;
  private tables: DbTable[] = [];
  constructor ({ dbName, version = 1, tables }: IIndexDB) {
    this.dbName = dbName;
    this.version = version;
    this.INDEXDB_ERROR = lang.templateByUuid('UID:P_CORE-YNF-FE_1894FE9404500000', '数据库链接不存在');
    this.tables = tables;
  }

  // 打开数据库
  openDB () {
    return new Promise<IndexDB>((resolve, reject) => {
      // const indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB;
      const request = window.indexedDB.open(this.dbName, this.version);
      request.onerror = (e) => {
        reject(e);
      };
      request.onsuccess = (e: any) => {
        this.db = e.target.result;
        console.log(`连接数据库${this.dbName}成功`);
        resolve(this);
      };
      request.onupgradeneeded = (e) => {
        this.tables.forEach((item: DbTable) => {
          this.createTable((e.target as any).result, item);
        });
      };
    });
  }

  // 关闭数据库
  closeDB () {
    return new Promise((resolve, reject) => {
      try {
        if (!this.db) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(lang.templateByUuid('UID:P_CORE-YNF-FE_1894FE9404500001', '请打开数据库'));
        } else {
          this.db.close();
          this.db = null;
          resolve(true);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  // 删除数据库
  deleteDB () {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        try {
          await this.closeDB();
        } catch (e) {
          // console.log(e);
        }
        const request = window.indexedDB.deleteDatabase(this.dbName);
        request.onsuccess = () => {
          console.log(`删除数据库${this.dbName}成功`);
          resolve(true);
        };
        request.onerror = (res) => {
          console.error(`删除数据库${this.dbName}失败`);
          reject(res);
        };
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * 清空表 返回成功失败
   * @param tableName 表名
   * @returns resolve
   */
  clearTable (tableName: string) {
    return new Promise((resolve, reject) => {
      if (this.db) {
        try {
          const store = this.db
            .transaction(tableName, 'readwrite')
            .objectStore(tableName);
          const request = store.clear();
          request.onerror = resolve;
          request.onsuccess = resolve;
        } catch (e) {
          console.log(`清空表${tableName}失败，异常${e}`);
          reject(e);
        }
      } else {
        reject(this.INDEXDB_ERROR);
      }
    });
  }
  //   /**
  //    * 通过实例 删除表名
  //    * @param tableName  表名
  //    * @returns
  //    */
  //   deleteTable(tableName: string) {
  //     return new Promise((resolve, reject) => {

  //     });
  //   }

  /**
   * 创建table
   * @param idb
   * @param param DBTable
   */
  private createTable (
    idb: any,
    {
      tableName,
      // 主键 id 自增
      options = { keyPath: 'id', autoIncrement: true },
      indexs = []
    }: DbTable
  ) {
    try {
      if (!idb.objectStoreNames.contains(tableName)) {
        const store = idb.createObjectStore(tableName, options);
        // 索引：indexs
        for (const { key, option } of indexs) {
          store.createIndex(key, key, option);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 插入数据
   * @param {tableName : 表名  data :数据 }
   * @returns  添加 成功 返回true ，添加失败 e.target.result
   */
  insert (tableName: string, data: any) {
    return new Promise((resolve, reject) => {
      const tableObj = this.tables.find((item) => item.tableName === tableName);
      if (tableObj) {
        const objStore = this.createTransaction(tableName, 'readwrite');
        if (objStore) {
          const request = objStore.put(data);
          request.onsuccess = (e) => {
            console.log(
              `成功保存至dbName[${// @notranslate
                this.dbName
              }] dbTableName[${tableName}], id为${// @notranslate
                (e?.target as any).result
              }的数据`// @notranslate
            );
            resolve(true);
          };
          request.onerror = (e: any) => {
            console.log('保存失败');
            console.error(e.target.result.error);
            reject(e.target.result);
          };
        } else {
          reject(this.INDEXDB_ERROR);
        }
      } else {
        console.log(`数据库里没有${tableName}表`);
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(false);
      }
    });
  }

  /**
   * 根据Key  value  查询数据 ，直接使用query 也可以
   * @param param0
   * @returns
   */
  queryByKeyValue (
    tableName: string,
    key: string | number,
    value: string | number
  ) {
    return this.query(tableName, (data: any) => {
      return data[key] === value;
    });
  }

  /**
   * 根据主键值 查询 数据
   * @param param
   * @returns 查询数据
   */
  queryByPrimaryKey (tableName: string, key: string | number) {
    return new Promise((resolve, reject) => {
      const objStore = this.createTransaction(tableName, 'readonly');
      if (objStore) {
        const request = objStore.get(key);
        request.onsuccess = function (e) {
          resolve((e.target as any).result);
        };
        request.onerror = function (e) {
          reject(e);
        };
      } else {
        reject(this.INDEXDB_ERROR);
      }
    });
  }

  // 查询表里的全部数据
  queryAll (tableName: string) {
    return this.query(tableName, () => {
      return true;
    });
  }

  /**
   * 根据条件查询 数据
   * @param tableName
   * @param condition 条件函数
   * @returns
   */
  query (tableName: string, condition: Function) {
    const res: any[] = [];
    return new Promise((resolve, reject) => {
      const objStore = this.createTransaction(tableName, 'readonly');
      if (objStore) {
        const request = objStore.openCursor();
        request.onsuccess = (e) => {
          this.cursorFn(e, {
            condition,
            handler: ({ currentValue }: any) => {
              res.push(currentValue);
            },
            success: () => resolve(res)
          });
        };
        request.onerror = reject;
      } else {
        reject(this.INDEXDB_ERROR);
      }
    });
  }

  /**
   * @param tableName:表名
   * @param condition:每条数据的回调
   * @param handler:变更函数
   * @returns 变更的数据list
   */
  update (tableName: string, condition: Function, handler: Function) {
    const res: any = [];
    return new Promise((resolve, reject) => {
      const objStore = this.createTransaction(tableName, 'readwrite');
      if (objStore) {
        // 打开 游标
        const request = objStore.openCursor();
        request.onsuccess = (e) => {
          this.cursorFn(e, {
            condition,
            handler: ({ cursor, currentValue }: any) => {
              // 执行传入修改函数
              const result = handler(currentValue);
              res.push(result);
              // 更新数据
              cursor.update(result);
            },
            success: () => resolve(res)
          });
        };
      } else {
        reject(this.INDEXDB_ERROR);
      }
    });
  }

  /**
   * 根据条件 删除数据，返回 删除的数据列表
   * @param {tableName: 表名  condition：条件 }
   * @returns 删除的数据list
   */
  delete (tableName: string, condition: Function): any {
    const res: any[] = [];
    return new Promise((resolve, reject) => {
      const objStore = this.createTransaction(tableName, 'readwrite');
      if (objStore) {
        const request = objStore.openCursor();
        request.onsuccess = (e) => {
          this.cursorFn(e, {
            condition,
            handler: ({ cursor, currentValue }: any) => {
              // 收集删除的数据
              res.push(currentValue);
              // 删除数据
              cursor.delete();
            },
            success: () => resolve(res)
          });
        };
        request.onerror = reject;
      } else {
        reject(this.INDEXDB_ERROR);
      }
    });
  }

  /**
   * 创建链接对象
   * @param tableName
   * @param mode
   * @returns IDBObjectStore
   */
  private createTransaction (
    tableName: string,
    // eslint-disable-next-line no-undef
    mode: IDBTransactionMode = 'readwrite'
  ) {
    try {
      return this.db
        ? this.db.transaction(tableName, mode).objectStore(tableName)
        : null;
    } catch (e) {
      return null;
    }
  }

  /**
   * 游标通用处理函数
   * @param e
   * @param condition condition: 查询条件函数,  handler 方法  success：回调
   */
  private cursorFn (e: any, { condition, handler, success }: any): void {
    const cursor = e.target.result;
    // 如果有值，继续hander push
    if (cursor) {
      // 当前数据
      const currentValue = cursor.value;
      if (condition(currentValue)) handler({ cursor, currentValue });
      cursor.continue();
    } else {
      success();
    }
  }
}

/**
 *
 * @param dbName
 * @param version
 * @param tables
 * @returns 返回IndexDB 数据库实例 ，后续可以直接调用实例上的方法 处理
 */
export const init = async (
  dbName: string,
  version: number,
  tables: DbTable[]
): Promise<IndexDB> => {
  return new IndexDB({
    dbName,
    version,
    tables
  }).openDB();
};
export default {
  init
};
